module.exports = __webpack_public_path__ + "static/img/snow.7ac09ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/snow.png
// module id = yC8Z
// module chunks = 2